import Moment from 'moment'

/**
 * 赛况卡片展示条件（与时间/场地/裁判行一致）
 */
export function refereeList(info) {
  return Array.isArray(info && info.referee) ? info.referee : []
}

export function mainRefereeTextFromInfo(info) {
  const names = []
  const seen = {}
  refereeList(info).forEach(r => {
    const role = String(r.role || '').trim()
    if (role.includes('助理')) return
    if (!(role === '主裁判' || role === '主裁判员' || role.startsWith('主裁'))) return
    const n = String(r.name || '').trim()
    if (!n || seen[n]) return
    seen[n] = 1
    names.push(n)
  })
  return names.length ? names.join('、') : ''
}

export function assistantRefereeTextFromInfo(info) {
  const names = []
  const seen = {}
  refereeList(info).forEach(r => {
    const role = String(r.role || '').trim()
    if (!role.includes('助理')) return
    const n = String(r.name || '').trim()
    if (!n || seen[n]) return
    seen[n] = 1
    names.push(n)
  })
  return names.length ? names.join('、') : ''
}

export function hasMatchOutsData(info) {
  const inf = info || {}
  const hasTime = !!inf.beginDate && Moment(inf.beginDate).isValid()
  const hasLocation = !!String(inf.location || '').trim()
  const hasMain = !!mainRefereeTextFromInfo(inf)
  const hasAssistant = !!assistantRefereeTextFromInfo(inf)
  return hasTime || hasLocation || hasMain || hasAssistant
}
